module.exports = __webpack_public_path__ + "img/phia.60808690.png";